import React, { useEffect, useState } from 'react';
import { api } from '../../api.js';
import PageHeader from '../../components/PageHeader.jsx';
import { Icon, SECTION_COLOR } from '../../icons.jsx';

export default function Accounting() {
  const [invoices, setInvoices] = useState(null);

  useEffect(() => {
    api('/accounting/invoices').then(setInvoices).catch(() => setInvoices([]));
  }, []);

  return (
    <div>
      <PageHeader icon={Icon.accounting} title="Accounting" subtitle="Invoices and payment status" color={SECTION_COLOR.accounting} />
      {invoices && invoices.length === 0 && <p className="empty">No invoices yet.</p>}
      {invoices && invoices.length > 0 && (
        <table>
          <thead><tr><th>Invoice #</th><th>Amount</th><th>Due</th><th>Status</th></tr></thead>
          <tbody>
            {invoices.map(i => (
              <tr key={i.id}><td>#{i.id}</td><td>${i.amount}</td><td>{i.due_date}</td><td>{i.status}</td></tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
